import React from "react"
import styled from "@emotion/styled"
import { navigate } from "gatsby-link"
import { Box, Flex } from "@rebass/grid/emotion"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"
import { ButtonWildMen } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWildMen"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

const ContentSection = styled(Flex)`
  flex-direction: column;
  background: #f8f8f5;
  border-radius: 4px;
  position: relative;
  margin: -16px auto 0;
  padding: 24px 16px;
  @media (min-width: 768px) {
    margin: -24px auto 0;
    padding: 32px 40px;
  }
  @media (min-width: 1280px) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex-direction: row;
    padding: 40px 40px;
    margin: 0;
    width: 65%;
    max-width: 977px;
    h2 {
      font-size: 40px !important;
      line-height: 36px !important;
    }
  }

  .max-w-special {
    max-width: 608px;
    margin: 0 auto;
    @media (min-width: 1024px) {
      max-width: 700px;
    }
    @media (min-width: 1280px) {
      max-width: 515px;
      margin: 0;
    }
  }
`

const FullWrap = styled(Flex)`
  flex-direction: column;
  @media (min-width: 1280px) {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 40px;
  }
`

const StatWrap = styled(Flex)`
  background: #0f3956;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 4px;
  align-items: center;
  @media (min-width: 768px) {
    gap: 8px;
  }
`

const ImgBox = styled(Box)`
  img {
    margin: 0 auto;
    max-width: 135px;
    @media (min-width: 768px) {
      max-width: 185px;
    }
    @media (min-width: 1280px) {
      max-width: 274px;
    }
  }
`
const ButtonBox = styled(Box)`
  button {
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
    display: block;
    @media (min-width: 1280px) {
      margin: 0;
    }
  }
`

const BannerWrap = styled(Flex)`
  position: relative;
  overflow-x: hidden;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.data?.mobileImage});
  background-size: cover;
  background-position: 100% 50%;
  height: 54dvw;
  @media (min-width: 768px) {
    height: 33dvw;
    background-image: url(${(props) => props.data?.tabletImage});
    margin-top: 0;
  }
  @media (min-width: 1280px) {
    border-radius: 4px;
    height: 515px;
    align-items: center;
    background-image: url(${(props) => props.data?.desktopImage});
  }
  @media (min-width: 1800px) {
    //height: 700px;
  }
`

const Nutraceutical = ({ data }) => {
  const { stat, statinfo, heading, subheading, duoImage, ctaLabel, link } = data

  const handleCtaClick = () => {
    segmentEvent("Marketing CTA Clicked", {
      destination: link,
      module_location: "bottom_fold",
      text: ctaLabel,
      type: "link",
    })
    navigate(link)
  }

  const Stats = (
    <StatWrap>
      <Box minWidth={[65, 65, 165, 122]}>
        <TextElementMen
          element="p"
          text={stat}
          className={
            "title--xlarge text-men-base-default hide-md-up text-center"
          }
        />
        <TextElementMen
          element="p"
          text={stat}
          className={
            "title--large text-men-base-default show-md-up text-center"
          }
        />
      </Box>
      <Box flex={1}>
        <TextElementMen
          element="p"
          text={statinfo}
          className={"body--large-b text-men-base-default hide-md-up"}
        />
        <TextElementMen
          element="p"
          text={statinfo}
          className={"body--xlarge-b text-men-base-default show-md-up"}
        />
      </Box>
    </StatWrap>
  )

  const CONTENT = (
    <ContentSection>
      <Box width={[1, 1, 1, "auto"]} flex={1}>
        <Box className={`max-w-special`}>
          <TextElementMen
            element="h2"
            text={heading}
            className={"title--large text-men-secondary-secondary text-center"}
          />
        </Box>
        <Box className={`max-w-special`} pt={[32, 32, 32, 16]}>
          {Stats}
        </Box>
        <Box maxWidth={[608]} mx={["auto"]} className={`show-xlg-up`} pt={[32]}>
          <TextElement
            element="p"
            text={subheading}
            className={"body--large text-men-secondary-secondary"}
          />
          <ButtonBox pt={[32]}>
            <ButtonWildMen
              secondary
              className="cta-btn"
              label={ctaLabel}
              onClick={handleCtaClick}
            />
          </ButtonBox>
        </Box>
      </Box>
      <ImgBox py={[24, 24, 16, 32]} width={[1, 1, 1, 274]} mx={["auto"]}>
        <img src={duoImage} alt={``} role={`presentation`} />
      </ImgBox>
      <Box className={`hide-xlg-up max-w-special`}>
        <TextElement
          element="p"
          text={subheading}
          className={"body--large text-men-secondary-secondary"}
        />
        <ButtonBox pt={[24, 24, 16, 32]}>
          <ButtonWildMen
            secondary
            className="cta-btn"
            label={ctaLabel}
            onClick={handleCtaClick}
          />
        </ButtonBox>
      </Box>
    </ContentSection>
  )

  return (
    <FullWrap>
      <BannerWrap width={[1]} data={data}>
        <Box className={` show-xlg-up`} width={[1]}>
          {CONTENT}
        </Box>
      </BannerWrap>
      <Box className={`wild-container hide-xlg-up`}>{CONTENT}</Box>
    </FullWrap>
  )
}

export default Nutraceutical
